<template>
    <div>
        <b-row v-for="(item, index) of listItems" :key="index" style="padding-top:8px" align-v="center">
            <b-col :class="isMobile ? 'text-left' : 'text-right'" cols="12" md="4">
                <span :class="isMobile ? 'text-success' : ''">{{ item.name }} <strong class="text-danger" v-if="item.required"> * </strong></span>
            </b-col>
            <b-col cols="12" md="8">
                <template v-if="editable">
                    <b-input 
                        v-if="item.datatype ==='string'" 
                        v-model="item.info" 
                        @keyup="emitUpdate(item.link, item.info)" 
                        :placeholder="`Например: ${item.example}`"
                        :state="checkState(item.required, item.info, item.minlen)"/>
                    <b-form-checkbox 
                        @change="emitUpdate(item.link, !item.info)" 
                        v-if="item.datatype ==='boolean'" 
                        v-model="item.info" /> 
                </template>
                <template v-if="!editable">
                    <span>{{ item.info }}</span>
                </template>
            </b-col>
        </b-row>
        <b-row v-if="requiredEmptyItems.length > 0">
            <b-col class="text-right"  cols="12" md="6">
                <hr/>
                Оставшиеся поля, обязательные к заполнению:
            </b-col>
            <b-col  cols="12" md="6">
                <hr/>
                <template v-for="(item, index) of requiredEmptyItems">
                    <span :key="index">{{item}} <br/></span>
                </template>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: {
        items: Array,
        company: Object, 
        editable: {
            type: Boolean,
            default: false
        },
        allowNextStep:  Boolean,
    },
    data() {
        return {
            requiredEmptyItems: []
        }
    },
    mounted() {
        
    },
    methods: {
        checkState(requred, value, minlen){
            if(requred === true) {
                if(minlen === 0) return value ? true : false
                else return value && value.length >= minlen ? true : false
            } else return value ? true : null
        },
        emitUpdate(link, value) {
            _.set(this.company, link, value)
            this.$emit('update:company', this.company)
            this.$emit('updateStore')
            this.$emit('update:allowNextStep', this.checkRequired())
        },
        checkRequired() {
            this.requiredEmptyItems = []
            let titles = this.$store.getters.TITLES
            for(let item of this.items) {
                let parsedItem = this.parseItem(item)
                if(parsedItem.required) {
                    let value = _.get(this.company, parsedItem.name, null)
                    let title = _.get(titles, parsedItem.name, null)
                    let check = this.checkState(parsedItem.required, value, parsedItem.minlen)
                    if(check === false) {
                        this.requiredEmptyItems.push(title)
                    }
                }
            }
            return this.requiredEmptyItems.length === 0 ? true : false
        },
        parseItem(item) {
            let required = item.includes('*')
            if(required) {
                let parts = item.split('*')
                let name = parts.length === 1 ? parts[0] : parts[1]
                let minlen = parts.length === 2 ? new Number(parts[0]) : 0
                return {
                    name: name,
                    minlen: minlen,
                    required: true
                }
            } else {
                return {
                    name: item,
                    minlen: 0,
                    required: false
                }
            }
        }
    },
    computed:{
        isMobile() { return window.innerWidth < 730 ? true : false},
        listItems() {
            let titles = this.$store.getters.TITLES
            let example = this.$store.getters.EXAMPLE
            let res = []
            if(this.company) {
                for(let item of this.items) {
                    let parsedItem = this.parseItem(item)
                    let specType = titles && titles.$types ? titles.$types.filter(t => t[0] === parsedItem.name) : []
                    let datatype = specType.length === 1 ? specType[0][1] : "string"
                    res.push({
                        link: parsedItem.name, 
                        datatype: datatype,
                        name: _.get(titles, parsedItem.name , ''),
                        example: _.get(example, parsedItem.name , ''),
                        info: _.get(this.company, parsedItem.name , ''),
                        required: parsedItem.required,
                        minlen: parsedItem.minlen
                    })
                }
            }
            this.$emit('update:allowNextStep', this.checkRequired())
            return res
        }
    }
}
</script>